/* The now-playing bar: artwork, metadata, scrubber, transport and extras. */

.np {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(14px + var(--safe-b));
  width: min(720px, calc(100vw - 28px));
  border-radius: var(--r-lg);
  padding: 12px 14px;
  display: grid;
  gap: 12px;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  transition:
    transform 0.5s var(--ease),
    opacity 0.4s;
}

.art {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  overflow: hidden;
  flex: none;
  background: linear-gradient(145deg, #e9f2ec, #d9e7e0);
  box-shadow:
    0 2px 8px rgba(16, 48, 34, 0.14),
    inset 0 0 0 0.5px rgba(255, 255, 255, 0.7);
  position: relative;
}

.art canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.art::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(150deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0) 46%);
}

.main {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.meta {
  min-width: 0;
}

.title,
.artist {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title {
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.artist {
  font-size: 12.5px;
  color: var(--ink-2);
  letter-spacing: -0.01em;
  line-height: 1.3;
  margin-top: 2px;
}

@media (max-width: 620px) {
  .np {
    width: calc(100vw - 16px);
    bottom: calc(8px + var(--safe-b));
    padding: 10px 11px 11px;
    border-radius: var(--r-md);
    gap: 10px;
    grid-template-columns: auto minmax(0, 1fr) auto;
  }

  .art {
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }
}

@media (max-height: 460px) and (orientation: landscape) {
  .np {
    width: min(560px, calc(100vw - 20px));
    padding: 8px 10px;
  }

  .art {
    width: 44px;
    height: 44px;
  }
}
